module.exports = __webpack_public_path__ + "static/media/SCALE_Screen2.20e1b3b2.png";